import { projectInvolvementTypeTitle } from '@internal/components/projects/helper/projects.helpers';
import { Project } from '@internal/types/projects';

/** True when markdown text has content beyond bullets and whitespace. */
export const hasTextContent = (text?: string | null): text is string =>
  Boolean(text && text.replace(/[-*•●\s]/gu, '').length);

const hourlyRateValue = (project: Project): string | null => {
  if (!project.candidateRatePerHour) return null;
  const comment = project.rateCommentForDev
    ? ` (${project.rateCommentForDev})`
    : '';
  return `$${project.candidateRatePerHour}/hour${comment}`;
};

export const basicInfoRows = (
  project: Project,
  { showRate = true }: { showRate?: boolean } = {}
) =>
  [
    {
      label: 'Hourly rate',
      value: showRate ? hourlyRateValue(project) : null,
    },
    {
      label: 'Involvement',
      value: project.projectWeeklyInvolvement
        ? `${project.projectWeeklyInvolvement}/week`
        : null,
    },
    {
      label: 'Project type',
      value: project.projectInvolvementType
        ? projectInvolvementTypeTitle(project.projectInvolvementType)
        : null,
    },
    { label: 'Duration', value: project.projectExpectedEngagementDuration },
    { label: 'Start date', value: project.projectPreferredStartDate },
    { label: 'Client time zone', value: project.projectClientTimeZone },
    { label: 'Overlap', value: project.projectRequiredOverlap },
  ].filter(row => Boolean(row.value));
